module.exports = __webpack_public_path__ + "img/restaurant-view-tabs04.d30ef884.svg";